import React, { memo, useRef, useEffect, useState, useCallback, useMemo } from 'react';
import { dates, formats, validators } from 'investira.sdk';
import {
  Stack,
  Card,
  CardHeader,
  Typography,
  CardContent,
  ToggleButtonGroup,
  ToggleButton
} from 'investira.react.components';
import { StocksChart } from 'investira.react.charts';

const PosicaoEvolucaoChart = memo(props => {
  const { posicoes = [] } = props;
  console.log('posicoes', posicoes);
  const chartRef = useRef(null);
  const [rangeSelected, setRangeSelected] = useState(2);

  function formatData(pData = []) {
    if (validators.isNull(pData)) {
      return [];
    }

    const xFormattedData = pData.map(xPoint => {
      const xDate = dates.toDate(xPoint.data).getTime();
      return [xDate, xPoint['financeiro']];
    });

    return xFormattedData;
  }

  const createChartOptions = useCallback(pPosicoes => {
    const to = new Date().getTime();
    const from = new Date(to - 365 * 24 * 3600 * 1000).getTime();

    const xSeries = pPosicoes.map(pPosicao => {
      const xData = pPosicao.data;

      return {
        name: pPosicao.carteira,
        type: 'line',
        data: formatData(xData)
      };
    });

    const xOptions = {
      title: false,
      chart: {
        zooming: {
          type: 'x'
        }
        // events: {
        //   load: function () {
        //     const chart = this;
        //     chart.xAxis[0].setExtremes(from, to);
        //   },
        // },
      },
      rangeSelector: {
        enabled: false,
        buttons: [
          {
            type: 'month',
            count: 1,
            text: '1M'
          },
          {
            type: 'month',
            count: 6,
            text: '6M'
          },
          {
            type: 'year',
            count: 1,
            text: '1A'
          },
          {
            type: 'year',
            count: 2,
            text: '2A'
          },
          {
            type: 'year',
            count: 3,
            text: '3A'
          },
          {
            type: 'year',
            count: 5,
            text: '5A'
          },
          {
            type: 'ytd',
            text: 'YTD'
          },
          {
            type: 'all',
            text: 'MÁX.'
          }
        ],
        selected: rangeSelected
      },
      xAxis: { type: 'datetime', crosshair: true },
      yAxis: {
        type: 'linear',
        opposite: false,
        title: false,
        labels: {
          formatter: function () {
            return `${formats.friendlyNumber(this.value, 2, true)}`;
          }
        }
      },
      series: xSeries,
      tooltip: {
        formatter: function (_tooltip) {
          const xDate = formats.formatDateCustom(this.point.x, 'DD/MMM/YYYY');
          const xFinanceiro = formats.formatNumber(this.point.y, 2, true);

          return `
          <span style="font-size: 1em"><b>${xDate}</b></span><br/>
          <span style="color:${this.color}">\u25CF</span>
          ${this.series.name}: <b>${xFinanceiro}</b>
          `;
        }
      }
    };

    return xOptions;
  }, []);

  const [options, setOptions] = useState(null);

  const handleRangeSelect = (type, count, index) => {
    const xChart = chartRef.current;
    const xTo = new Date().getTime();
    let xFrom;

    switch (type) {
      case 'month':
        xFrom = new Date(xTo - count * 30 * 24 * 3600 * 1000).getTime();
        break;
      case 'year':
        xFrom = new Date(xTo - count * 365 * 24 * 3600 * 1000).getTime();
        break;
      case 'ytd':
        const startOfYear = new Date(new Date().getFullYear(), 0, 1).getTime();
        xFrom = startOfYear;
        break;
      case 'all':
        xFrom = null;
        break;
      default:
        return;
    }
    setRangeSelected(index);
    xChart.xAxis[0].setExtremes(xFrom, xTo);
  };

  useEffect(() => {
    const xOptions = createChartOptions(posicoes);

    setOptions(xOptions);
  }, [posicoes, createChartOptions]);

  if (validators.isEmpty(posicoes[0]?.data)) {
    return null;
  }

  if (validators.isNull(options)) {
    return null;
  }

  return (
    <Card sx={{ flex: 1, minHeight: 0 }}>
      <CardHeader
        title={
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Evolução da Posição
            </Typography>
            <Stack>
              <Stack spacing={2} direction="row">
                <ToggleButtonGroup value={rangeSelected} size="small" color="primary" fullWidth>
                  {options.rangeSelector.buttons.map((xOption, xIndex) => {
                    return (
                      <ToggleButton
                        key={xOption.text}
                        onClick={() => handleRangeSelect(xOption.type, xOption.count, xIndex)}
                        value={xIndex}>
                        {xOption.text}
                      </ToggleButton>
                    );
                  })}
                </ToggleButtonGroup>
              </Stack>
            </Stack>
          </Stack>
        }
      />
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minHeight: '200px'
        }}>
        <StocksChart
          key={'posicao_evolucao'}
          ref={chartRef}
          options={options}
          // isLoading={isIndicadorLoading}
        />
      </CardContent>
    </Card>
  );
});

export default PosicaoEvolucaoChart;
